import React, { useMemo } from "react";
import styles from "./OrderInformation.module.css";
import { Divider, Header, Icon, List, ListContent, ListIcon, ListItem } from "semantic-ui-react";
import { useSelector } from "react-redux";
import {
  IConveyorBox,
  IConveyorBoxReviewModel,
} from "../../../lib/interfaces/ConveyorBox/IConveyorBox";
import Barcode from "../Barcode";
import { formatSwedishDate } from "../../../utils/formatting/date";
import { SERVICES_BASE_URL } from "../../../utils/Constants";

type Props = {
  orderNumber: string;
  weight: number;
  latestShipping: string;
  shippingMethod: string;
  iPackBoxBarcode: string;
};

const OrderInformation = () => {
  const conveyorBoxReview: IConveyorBox = useSelector(
    (state: any) => state.conveyorBoxReviewReducer
  );
  const { orderNumber, boxBarcode, shipping } = conveyorBoxReview;
  const latestShippingDate = formatSwedishDate(shipping.latestShippingTime);
  return (
    <>
      <Divider horizontal>
        <Header as="h3">
          <Icon name="user" />
          Orderinformation
        </Header>
      </Divider>
      <div className={styles["order-information"]}>
        <List size="large">
          <ListItem>
            <ListIcon name="box" />
            <ListContent>
              <b>Ordernummer</b> <Barcode value={orderNumber.toString()} formatted={false} />
            </ListContent>
          </ListItem>
          <ListItem>
            <ListIcon name="barcode" />
            <ListContent>
              <b>Lådnummer</b>
              <Barcode value={boxBarcode} />
            </ListContent>
          </ListItem>
          <ListItem>
            <ListIcon name="shipping" />
            <ListContent>
              <div className={styles["list-content__shipping"]}>
                <div className="flexColumn">
                  <b>Leverera ut senast</b> {latestShippingDate}
                </div>

                <div className={styles["shipping-method"]}>
                  <img
                    alt="shippingmethodlogo"
                    src={`${SERVICES_BASE_URL}/images/shipping-method/large/${shipping.shippingMethod}.png`}
                  ></img>
                </div>
              </div>
            </ListContent>
          </ListItem>
        </List>
      </div>
    </>
  );
};

export default OrderInformation;
